import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import placeholder from '../../assests/images/vertPlaceholder.jpg';
import ZoomThumbnail from './zoomThumbnail.js';
import parse from 'html-react-parser';

class Thumbnail835X1080 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 900,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 2000,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },

                ],
            },
            Muted: false,
            isVideoThumbonHover: false,
            thumbnailIndex: 0,
            itemDescription: '',
            isMutedThumbnailVideo: false,
            zoomThumbnailImgurl: '',
            hasTrailer_dataItemIndex: null
        }
    }


    hoverThumbnail = (e, key, entryidmain, trailer_data) => {
        this.setState({ isVideoThumbonHover: true, thumbnailIndex: key })

        if (trailer_data.length !== 0) {
            this.setState({ hasTrailer_dataItemIndex: key })
        }

        if (localStorage.getItem('isMutedThumbnailVideo') === 'true') {
            this.setState({ isMutedThumbnailVideo: true })
        } else {
            this.setState({ isMutedThumbnailVideo: false })
        }

        localStorage.setItem('isVideoThumbonHover', true)


    }

    hoverOutThumbnail = () => {
        this.setState({ isVideoThumbonHover: false })
        this.setState({ hasTrailer_dataItemIndex: null })
        localStorage.setItem('isVideoThumbonHover', false)
    }
    modaltoogle = (itms) => {
        this.setState({ isModel: !this.state.isModel, modaltog: itms })
        document.body.classList.add('overflow-hidden');
        document.querySelector('#header').classList.add('down')
    }
    modaltoogleclose = (itms) => {
        this.setState({ isModel: !this.state.isModel })
        document.body.classList.remove('overflow-hidden');
        document.querySelector('#header').classList.remove('down')
    }


    componentDidMount() {
        const theme = localStorage.getItem('themeColor');
        if (theme === 'blckThem') {
            this.setState({ placeholderImage: 'dark' })
        } else {
            this.setState({ placeholderImage: 'light' })
        }
        localStorage.setItem('isMutedThumbnailVideo', false)
    }

    render() {
        return (
            <div className="pt-3 sliderWrapperRef">
                <div className="row thm_slr_bx">
                    <div className="thm_hdng_wppr d-flex align-item-center justify-content-between">
                        <h3 className='d-flex align-items-center'>
                            {this.props.uniqId !== "season_list" && this.props.Itmdata.title_tag_name}
                            {this.props.uniqId === "season_list" && this.props.Itmdata.Parent_name}
                            {
                                this.props.Itmdata.categoryid !== undefined && this.props.Itmdata.categoryid !== null && this.props.Itmdata.cat_type === 'cat' ? <Link className="viewAllBtn ml-2 d-flex align-items-center" to={{
                                    pathname: `/viewall/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '')).toLowerCase()}/${this.props.Itmdata.categoryid !== null && this.props.Itmdata.categoryid !== undefined ? this.props.Itmdata.categoryid : ''}`,
                                    state: this.props.Itmdata.title_tag_name
                                }}><span>View All</span>  <i className="fa fa-angle-right ml-1" aria-hidden="true"></i></Link> : ''
                            }
                        </h3>
                        {/* {
                            this.props.Itmdata.cat_type !== undefined && this.props.Itmdata.cat_type !== null && this.props.Itmdata.cat_type !== "" ? <Link to={`/viewall/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '')).toLowerCase()}/${this.props.Itmdata.categoryid !== null && this.props.Itmdata.categoryid !== undefined ? this.props.Itmdata.categoryid : ''}`}  
                            
                            >View All</Link> : ''
                        } */}

                        {/* {  this.props.Itmdata.cat_type === "cat" ? <Link to={`/video/cat/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '')).toLowerCase()}/${this.props.Itmdata.categoryid !== null && this.props.Itmdata.categoryid !== undefined ? this.props.Itmdata.categoryid : ''}`} className="ml-auto" ></Link>: ''} */}

                    </div>
                    <Slider {...this.state.settings} className='thumb_slider position-relative vrtcl_sldr-2' >
                        {
                            this.props.Itmdata !== undefined && this.props.Itmdata !== null && this.props.Itmdata.search_tag !== undefined && this.props.Itmdata.search_tag !== null && this.props.Itmdata.search_tag.map((itms, key) => {
                                //  
                                let isPremium = itms.ispremium !== null && itms.ispremium === 1 ? 'thm_slr_itm_img prmum-txt' : 'thm_slr_itm_img';
                                return (
                                    <div className="thm_sldr_itm" onMouseOver={(e) => this.hoverThumbnail(key)} onMouseLeave={(e) => this.hoverOutThumbnail(key)} key={key}>
                                        <div className={`${isPremium} wtch-lst`}>
                                            {
                                                this.props.Itmdata.cat_type === "cat" ? <Link to={`/video/cat/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}`} className={`box`} key={'carousel_835x1080_' + key}>
                                                    {
                                                        this.props.Itmdata.cat_type === 'cat' ?
                                                            <div className={`placeholder vert ${this.state.hasTrailer_dataItemIndex === key ? 'hide' : 'show'}`}>
                                                                <img alt="" src={placeholder} className="w-100 placeholderImg" />
                                                                <div className="thumbImg">
                                                                    <FadeIn height={323} >
                                                                        {onload => (
                                                                            <img
                                                                            src={itms.thumburl.size_1080_835 ? itms.thumburl.size_1080_835 + "/width=250/height=323/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=250/height=323/quality=100" : itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=250/height=323/quality=100" : itms.thumburl.size_default + "/width=250/height=323/quality=100"}
                                                                            alt="" key={'carousel_835x1080_'+key}
                                                                            onLoad={onload}
                                                                            className="thumbPlaceholder"
                                                                        />
                                                                        )}
                                                                    </FadeIn>
                                                                </div>
                                                            </div>

                                                            :
                                                            <div className={`placeholder vert ${this.state.hasTrailer_dataItemIndex === key ? 'hide' : 'show'}`}>
                                                                <img alt="" src={placeholder} className="w-100 placeholderImg" />
                                                                <div className="thumbImg">
                                                                    <FadeIn height={290} >
                                                                        {onload => (
                                                                            <img
                                                                            src={itms.catthumburl.size_1080_835 ? itms.catthumburl.size_1080_835 + "/width=250/height=323/quality=100" : itms.catthumburl.v_catthumburl ? itms.catthumburl.v_catthumburl + "/width=250/height=323/quality=100" : itms.catthumburl.h_catthumburl ? itms.catthumburl.h_catthumburl + "/width=250/height=323/quality=100" : itms.catthumburl.size_default + "/width=250/height=323/quality=100"}
                                                                            alt="" key={'carousel_835x1080_' + key}
                                                                            onLoad={onload}
                                                                            className="thumbPlaceholder"
                                                                        />
                                                                        )}
                                                                    </FadeIn>
                                                                </div>
                                                            </div>

                                                    }
                                                </Link> : <Link to={`/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}`} className={`box`} key={'carousel_835x1080_' + key}>
                                                    {
                                                        this.props.Itmdata.cat_type === 'cat' ?
                                                            <div className={`placeholder vert ${this.state.hasTrailer_dataItemIndex === key ? 'hide' : 'show'}`}>
                                                                <img alt="" src={placeholder} className="w-100 placeholderImg" />
                                                                <div className="thumbImg">
                                                                    <FadeIn height={290} >
                                                                        {onload => (
                                                                            <img
                                                                                src={itms.thumburl.size_1080_835 ? itms.thumburl.size_1080_835 + "/width=250/height=323/quality=100" : itms.thumburl.v_thumburl ? itms.thumburl.v_thumburl + "/width=250/height=323/quality=100" : itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl + "/width=250/height=323/quality=100" : itms.thumburl.size_default + "/width=250/height=323quality=100"} alt="" key={'carousel_835x1080_' + key}
                                                                                onLoad={onload}
                                                                                className="thumbPlaceholder"
                                                                            />
                                                                        )}
                                                                    </FadeIn>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={`placeholder vert ${this.state.hasTrailer_dataItemIndex === key ? 'hide' : 'show'}`}>
                                                                <img alt="" src={placeholder} className="w-100 placeholderImg" />
                                                                <div className="thumbImg">
                                                                    <FadeIn height={290} >
                                                                        {onload => (
                                                                            <img
                                                                                src={itms.catthumburl.size_1080_835 ? itms.catthumburl.size_1080_835 + "/width=250/height=323/quality=100" : itms.catthumburl.v_catthumburl ? itms.catthumburl.v_catthumburl + "/width=250/height=323/quality=100" : itms.catthumburl.h_catthumburl ? itms.catthumburl.h_catthumburl + "/width=250/height=323/quality=100" : itms.catthumburl.size_default + "/width=250/height=323/quality=100"} alt="" key={'carousel_835x1080_' + key}
                                                                                onLoad={onload}
                                                                                className="thumbPlaceholder"
                                                                            />
                                                                        )}
                                                                    </FadeIn>
                                                                </div>
                                                            </div>

                                                    }
                                                </Link>
                                            }
                                        </div>

                                        {
                                            this.state.isVideoThumbonHover === true && this.state.thumbnailIndex === key &&
                                            <ZoomThumbnail title={itms.name} entryid={itms.entryid} flag={itms.favourite_status_flag} type={this.props.Itmdata.cat_type} description={itms.description !== null && itms.description !== undefined ? parse(itms.description.substr(0, 300) + '...') : null} pageLink={this.props.Itmdata.cat_type === "cat" ? `/video/cat/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}` : `/video/ser/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid !== null && itms.entryid !== undefined ? itms.entryid : window.btoa(itms.id)}`} playing={this.state.isVideoThumbonHover} isAddedinWishList={false} />
                                        }


                                    </div>

                                )
                            })
                        }
                    </Slider>
                </div >
            </div >

        );
    }
}

export default Thumbnail835X1080;
